<template>
  <admin-dashboard-view></admin-dashboard-view>
</template>

<script>
import asyncFactory from "@/client/extensions/modules/asyncComponentFactory.js";
import AdminDashboardView from "@/client/views/admin/Dashboard.vue";

export default {
  name: "AdminDashboardPage",
  layout: "adminDashboard",
  middleware: {
    acl: "adminUi|read",
  },
  data: function () {
    return {};
  },
  meta: "admin.dashboard.title",
  components: {
    AdminDashboardView,
  },
};
</script>

<style scoped lang="scss"></style>
